module.exports = __webpack_public_path__ + "img/imgLogo.7dbe6a27.png";